import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from '../../../models/ladder.model';
import { Level } from '../../../models/level.model';
import { Score } from '../../../models/score.model';

@Component({
  selector: 'admin-tourney',
  templateUrl: './tourneybuilder.component.html',
  styleUrls: ['./tourneybuilder.component.scss']
})
export class AdminTournamentBuilderComponent implements OnInit {
  public pairingForm: FormGroup;
  public result: string;
  public ladders: Ladder[] = [];
  public levels: Level[] = [];

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.pairingForm = fb.group({
      ladderId: new FormControl(''),
      levelId: new FormControl(1),
      players: new FormArray([
      ])
    });
    this.pairingForm.controls.ladderId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        //this.getPlayers(newVal, this.pairingForm.value.levelId);
        this.getLevels(newVal);
      }
    );
    this.pairingForm.controls.levelId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        this.getPlayers(this.pairingForm.value.ladderId, newVal);
      }
    );
  }

  private getLevels(ladderId: string) {
    if (ladderId.length == 0) return;
    const headers = new HttpHeaders();
    let params = new HttpParams().set('_ladderId', ladderId)

    this.http.get<Level[]>(`/activeLevelsByLadderId?ladderId=${ladderId}`, { headers, params }).subscribe(
      (resp) => {
        this.levels = resp.map(l => new Level(l));
      }
    );
  }

  public playerScoreResp: Score[] = [];
  private getPlayers(ladderId: string, levelId: number) {
    if (ladderId.length == 0 || levelId == 0) return;
    const headers = new HttpHeaders();
    let params = new HttpParams()
      .set('_ladderId', ladderId)
      .set('_levelId', levelId.toString());
    this.http.get<Score[]>(`/score`, { headers, params }).subscribe(
      (resp2) => {
        this.playerScoreResp = resp2;
        const min = Math.min(6, resp2.length);
        for (let i = 0; i < min; i++) {
          (this.pairingForm.controls.players as FormArray).controls[i].setValue(resp2[i].opponent.id);
        }

        if (levelId < 10) {
          (this.pairingForm.controls.players as FormArray).controls[6].setValue("00000000-0000-0000-0000-00000000000" + levelId);
          (this.pairingForm.controls.players as FormArray).controls[7].setValue("00000000-0000-0000-0000-00000000000" + levelId);
        }
        if (levelId >= 10) {
          (this.pairingForm.controls.players as FormArray).controls[6].setValue("00000000-0000-0000-0000-0000000000" + levelId);
          (this.pairingForm.controls.players as FormArray).controls[7].setValue("00000000-0000-0000-0000-0000000000" + levelId);
        }
      }
    )
  }






  get players(): FormArray {
    return this.pairingForm.get("players") as FormArray
  }
  ngOnInit() {
    for (let i = 0; i < 8; i++) {
      this.players.push(new FormControl(''));
    }
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
    // this.http.get<Level[]>('/levels').subscribe(
    //   (resp) => {
    //     this.levels.length = 0;
    //     for (const l of resp) {
    //       this.levels.push(new Level(l));
    //     }
    //   }
    // )
  }

  public doit(evt) {

    //return this.skillsForm.get("skills") as FormArray

    const values = this.pairingForm.value;
    //const playerArray = [values.player1, values.player2, values.player3, values.player4, values.player5, values.player6, values.player7, values.player8];
    this.http.post(`/Pairing/PairTournament`, this.pairingForm.value).subscribe(
      (resp: { result: string }) => {
        console.log(resp)
        this.result = resp.result;
      },
      (err) => console.error(err)
    )
    console.log(this.pairingForm.value.player)
  }

}
